import type { CSpellSettings } from "@cspell/cspell-types";

export function defineConfig(config: CSpellSettings) {
	return config;
}
